import React from "react";
import { PropTypes } from "prop-types";
import { css, withStyles } from "../../styles/withStyles";
import Styles from "./styles";

const Header = (props) => (
  <header
    {...css(
      props.styles.header,
      !!props.centeredLogo && props.styles["header--centered"],
      !!props.whiteLabel && props.styles["header--whitelabel"]
    )}
  >
    <div
      {...css(
        props.styles.logo,
        !!props.centeredLogo && props.styles["logo--centered"],
        !!props.whiteLabel && props.styles["logo--whitelabel"]
      )}
    >
      <div {...css(props.styles["logo-img"])} />
    </div>
    <div
      {...css(
        props.styles.children,
        !!props.whiteLabel && props.styles["children--whitelabel"]
      )}
    >
      {props.children}
    </div>
  </header>
);

Header.propTypes = {
  children: PropTypes.node,
  styles: PropTypes.object.isRequired,
};

export default withStyles(Styles)(Header);



// WEBPACK FOOTER //
// ./components/header/index.js